export default __webpack_public_path__ + "static/media/logo.42dd13c8.png";